import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { AhmedElshahatJobService } from '../../../../../services/ahmed-elshahat-job';
import { CountryCityService } from '../../../../../services/country-city.service';

@Component({
  selector: 'app-job-list',
  templateUrl: './job-list.component.html',
  styleUrl: './job-list.component.scss',
  providers: [
    {
      provide: MatPaginatorIntl,
      useFactory: getArabicPaginatorIntl
    }
  ]
})
export class JobListComponent implements OnInit {

  contentReady: boolean = false;
  noData: boolean = false;

  dataSource = new MatTableDataSource<any>([]);

  displayedColumns: string[] = [
    'title',
    'location',
    'job_type',
    'salary',
    'requirements',
    'skills',
    'exam',
    'status',
    'posted_at',
    'options'
  ];

  totalItems: number = 0;
  currentPage: number = 1;
  perPage: number = 10;
countries: any[] = [];
cities: any[] = [];
filteredCities: any[] = [];
  filters: any = {
    search: '',
    status: '',
    country_id: '',
    city_id: '',
    work_model: '',
    employment_type: '',
    page: 1,
    per_page: 10
  };

  constructor(
    private jobService: AhmedElshahatJobService,
    private router: Router,
      private countryCityService: CountryCityService,
  ) {}

  ngOnInit(): void {
      this.getCountriesAndCities();
    this.getJobs();
  }

  getJobs(): void {
    this.contentReady = false;
    this.noData = false;

    this.filters.page = this.currentPage;
    this.filters.per_page = this.perPage;

    this.jobService.getJobs(this.filters).subscribe({
      next: (res: any) => {
        const paginationData = res?.data;

        this.dataSource.data = paginationData?.data || [];

        this.totalItems = paginationData?.total || 0;
        this.currentPage = paginationData?.current_page || 1;
        this.perPage = Number(paginationData?.per_page || this.perPage);

        this.noData = this.dataSource.data.length === 0;
        this.contentReady = true;
      },
      error: (err: any) => {
        console.error('Get Jobs Error:', err);

        this.dataSource.data = [];
        this.totalItems = 0;
        this.noData = true;
        this.contentReady = true;

        alert('حدث خطأ أثناء تحميل الوظائف');
      }
    });
  }

  applyFilters(): void {
    this.currentPage = 1;
    this.getJobs();
  }

resetFilters(): void {
  this.filters = {
    search: '',
    status: '',
    country_id: '',
    city_id: '',
    work_model: '',
    employment_type: '',
    page: 1,
    per_page: this.perPage
  };

  this.filteredCities = this.cities;
  this.currentPage = 1;
  this.getJobs();
}

  refresh(): void {
    this.getJobs();
  }
getCountriesAndCities(): void {
  this.countryCityService.getCountries({ per_page: 1000 }).subscribe({
    next: (res: any) => {
      this.countries = this.extractArray(res);
    },
    error: (err: any) => {
      console.error('Get Countries Error:', err);
    }
  });

  this.countryCityService.getCities({ per_page: 1000 }).subscribe({
    next: (res: any) => {
      this.cities = this.extractArray(res);
      this.filteredCities = this.cities;
    },
    error: (err: any) => {
      console.error('Get Cities Error:', err);
    }
  });
}

onCountryChange(): void {
  this.filters.city_id = '';

  if (!this.filters.country_id) {
    this.filteredCities = this.cities;
  } else {
    this.filteredCities = this.cities.filter((city: any) => {
      return city.country_id == this.filters.country_id;
    });
  }

  this.applyFilters();
}

getJobCountryName(job: any): string {
  if (job?.country?.country_name_ar || job?.country?.country_name_en) {
    return job.country.country_name_ar || job.country.country_name_en;
  }

  if (job?.country_name_ar || job?.country_name_en) {
    return job.country_name_ar || job.country_name_en;
  }

  if (job?.country_id) {
    const country = this.countries.find((item: any) => item.id == job.country_id);
    return country ? (country.country_name_ar || country.country_name_en) : 'غير محدد';
  }

  return job?.country || 'غير محدد';
}

getJobCityName(job: any): string {
  if (job?.city?.city_name_ar || job?.city?.city_name_en) {
    return job.city.city_name_ar || job.city.city_name_en;
  }

  if (job?.city_name_ar || job?.city_name_en) {
    return job.city_name_ar || job.city_name_en;
  }

  if (job?.city_id) {
    const city = this.cities.find((item: any) => item.id == job.city_id);
    return city ? (city.city_name_ar || city.city_name_en) : 'غير محدد';
  }

  return job?.city || 'غير محدد';
}

private extractArray(res: any): any[] {
  if (Array.isArray(res)) {
    return res;
  }

  if (Array.isArray(res?.data?.data)) {
    return res.data.data;
  }

  if (Array.isArray(res?.data)) {
    return res.data;
  }

  return [];
}
  onPaginateChange(event: any): void {
    this.currentPage = event.pageIndex + 1;
    this.perPage = event.pageSize;
    this.getJobs();
  }

  changeStatus(job: any, status: 'draft' | 'published' | 'closed'): void {
    if (!job?.id) return;

    const oldStatus = job.status;

    job.status = status;

    this.jobService.updateJob(job.id, { status }).subscribe({
      next: () => {
        this.getJobs();
      },
      error: (err: any) => {
        console.error('Change Status Error:', err);

        job.status = oldStatus;

        alert('حدث خطأ أثناء تغيير حالة الوظيفة');
      }
    });
  }

  editJob(job: any): void {
    if (!job?.id) return;

    this.router.navigate(['/create-job', job.id]);
  }

  deleteJob(job: any): void {
    if (!job?.id) return;

    const jobTitle = job.title_ar || job.title_en || 'هذه الوظيفة';

    const confirmed = confirm(`هل أنت متأكد من حذف وظيفة "${jobTitle}"؟`);

    if (!confirmed) return;

    this.jobService.deleteJob(job.id).subscribe({
      next: () => {
        this.dataSource.data = this.dataSource.data.filter((item: any) => item.id !== job.id);
        this.totalItems = Math.max(this.totalItems - 1, 0);
        this.noData = this.dataSource.data.length === 0;
      },
      error: (err: any) => {
        console.error('Delete Job Error:', err);
        alert('حدث خطأ أثناء حذف الوظيفة');
      }
    });
  }

  getStatusLabel(status: string): string {
    switch (status) {
      case 'draft':
        return 'مسودة';

      case 'published':
        return 'منشورة';

      case 'closed':
        return 'مغلقة';

      default:
        return 'غير محدد';
    }
  }

  getWorkModelLabel(value: string): string {
    switch (value) {
      case 'on_site':
        return 'من مقر العمل';

      case 'remote':
        return 'عن بُعد';

      case 'hybrid':
        return 'هايبرد';

      default:
        return 'غير محدد';
    }
  }

  getEmploymentTypeLabel(value: string): string {
    switch (value) {
      case 'full_time':
        return 'دوام كامل';

      case 'part_time':
        return 'دوام جزئي';

      case 'contract':
        return 'تعاقد';

      case 'internship':
        return 'تدريب';

      default:
        return 'غير محدد';
    }
  }

  formatSalary(job: any): string {
    if (!job) return 'غير محدد';

    const currency = job.salary_currency || '';

    if (job.salary_type === 'competitive') {
      return 'راتب تنافسي';
    }

    if (job.salary_type === 'negotiable') {
      return job.salary_note || 'قابل للتفاوض';
    }

    if (job.salary_type === 'fixed') {
      if (job.salary_min) {
        return `${this.toArabicNumber(job.salary_min)} ${currency}`;
      }

      if (job.salary_max) {
        return `${this.toArabicNumber(job.salary_max)} ${currency}`;
      }
    }

    if (job.salary_type === 'range') {
      if (job.salary_min && job.salary_max) {
        return `${this.toArabicNumber(job.salary_min)} - ${this.toArabicNumber(job.salary_max)} ${currency}`;
      }

      if (job.salary_min) {
        return `يبدأ من ${this.toArabicNumber(job.salary_min)} ${currency}`;
      }

      if (job.salary_max) {
        return `حتى ${this.toArabicNumber(job.salary_max)} ${currency}`;
      }
    }

    return job.salary_note || 'غير محدد';
  }

  formatDate(date: any): string {
    if (!date) return 'غير محدد';

    const formatted = new Date(date).toLocaleDateString('ar-EG', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });

    return formatted;
  }

  toArabicNumber(value: any): string {
    if (value === null || value === undefined) return '';

    return value.toString().replace(/\d/g, (digit: string) => {
      return '٠١٢٣٤٥٦٧٨٩'[Number(digit)];
    });
  }
}


/* =========================
   Arabic Material Paginator
========================= */

export function getArabicPaginatorIntl(): MatPaginatorIntl {
  const paginatorIntl = new MatPaginatorIntl();

  const toArabicNumber = (value: any): string => {
    if (value === null || value === undefined) return '';

    return value.toString().replace(/\d/g, (digit: string) => {
      return '٠١٢٣٤٥٦٧٨٩'[Number(digit)];
    });
  };

  paginatorIntl.itemsPerPageLabel = 'عدد العناصر في الصفحة';
  paginatorIntl.nextPageLabel = 'الصفحة التالية';
  paginatorIntl.previousPageLabel = 'الصفحة السابقة';
  paginatorIntl.firstPageLabel = 'أول صفحة';
  paginatorIntl.lastPageLabel = 'آخر صفحة';

  paginatorIntl.getRangeLabel = (
    page: number,
    pageSize: number,
    length: number
  ): string => {
    if (length === 0 || pageSize === 0) {
      return `٠ من ${toArabicNumber(length)}`;
    }

    const startIndex = page * pageSize;
    const endIndex = Math.min(startIndex + pageSize, length);

    return `${toArabicNumber(startIndex + 1)} - ${toArabicNumber(endIndex)} من ${toArabicNumber(length)}`;
  };

  return paginatorIntl;
}